
import { cn } from '@/lib/utils';
import { hasFlagAsset, type FlagCode } from '@/lib/flag-codes';

export type { FlagCode };

/** Tiny decorative flag. Always `alt=""` — pair with aria-hidden on a parent
 *  when the surrounding copy already names the country/locale.
 *
 *  Assets are real 4×3 flag SVGs (not the emoji-style cartoons that shipped with
 *  the Windows/Edge letter-pair fix). Keep corners nearly square so they read as
 *  flags, not pills. */
export function FlagImg({
  code,
  width = 26,
  height = 19,
  className,
}: {
  code: FlagCode;
  width?: number;
  height?: number;
  className?: string;
}) {
  // Two selectable countries (Ascension, Tristan da Cunha) have no asset in
  // flag-icons; render a neutral block rather than a broken image icon.
  if (!hasFlagAsset(code)) {
    return (
      <span
        aria-hidden
        style={{ width, height }}
        className={cn('inline-block rounded-[1px] bg-muted', className)}
      />
    );
  }
  return (
    // eslint-disable-next-line @next/next/no-img-element -- tiny static SVG in /public
    <img
      src={`/flags/${code}.svg`}
      alt=""
      width={width}
      height={height}
      className={cn('rounded-[1px] object-cover', className)}
      draggable={false}
      loading="lazy"
    />
  );
}
